import EnterGroupBettingPoolLightbox from "./enter-group-betting-pool-lightbox";
import expandable from "./higher-order/expandable";
import NotificationButton from "./notification-button";
import pure from "./higher-order/pure";
import React from "react";

function createLongDescriptionMarkup(groupBettingPool) {
  return {
    __html: groupBettingPool.get("long_description_html")
  };
}

export default expandable(pure(function GroupBettingPool({ expanded, groupBettingPool, toggle }) {
  var isFull = groupBettingPool.get("remaining_entries") === 0;
  var text = "Buy Now";
  if (isFull) {
    text = "Full";
  }

  var lightbox;
  if (expanded) {
    lightbox = (
      <EnterGroupBettingPoolLightbox
        groupBettingPool={groupBettingPool}
        onClose={toggle} />
    );
  }
  /* eslint-disable react/no-danger */
  return (
    <div className="group-betting-pool">
      <h2>
        {groupBettingPool.get("name")}
      </h2>

      <div className="group-betting-pool_sub">
        {groupBettingPool.get("short_description")}
      </div>

      <div className="group-betting-pool_long-description" dangerouslySetInnerHTML={createLongDescriptionMarkup(groupBettingPool)} />

      <div>
        <NotificationButton
          amount={groupBettingPool.get("my_entries")}
          error={isFull}
          naked={isFull}
          onClick={toggle}
          primary={!isFull}
          small>
          {text}
        </NotificationButton>
      </div>

      {lightbox}
    </div>
  );
  /* eslint-enable react/no-danger */
}));
